module.exports = __webpack_public_path__ + "static/media/ic_01_networktopologies.9a1e206c.svg";